export const BREAKPOINTS = {
    desktop: 1024,
    desktopMedium: 1236,
    desktopWide: 1552,
    mobile: 320,
    mobileMedium: 375,
    mobileWide: 425,
    tablet: 768,
};
